export default __webpack_public_path__ + "static/media/eCSensorHumidity.4ff24f90.svg";